import React, { Suspense, PropsWithChildren, useRef } from "react";
import { ClapSpinner } from "react-spinners-kit";
import useComponentSize from "@rehooks/component-size";
import { Box, CircularProgress } from "@mui/material";
import ErrorBoundary from "./ErrorBoundary";
import Center from "./Center";
import { defaultChartHeight } from "./ApexCharts";
import palette from "../theme/palette";
import CranecastPalette from "../theme/cranecastTheme/palette";

export const Spinner = () => {
  const ref = useRef(null);
  const { width, height } = useComponentSize(ref);
  const size = Math.max(Math.min(width, height, 100), 40);
  return (
    <Center innerRef={ref || undefined}>
      <CircularProgress 
        size={size} 
        sx={{ 
          color: CranecastPalette.secondary.main 
        }} 
      />
    </Center>
  );
};

export const ChartProgressLoader = () => {
  return (
    <Box
      sx={{
        minHeight: defaultChartHeight,
        alignItems: "center",
        display: "flex",
      }}
    >
      <Center>
        <ClapSpinner
          size={30}
          frontColor={palette.common.fadedBlue}
          backColor={palette.common.neutral}
        />
      </Center>
    </Box>
  );
};

const Loader = (props: PropsWithChildren<{}>) => (
  <ErrorBoundary>
    <Suspense fallback={<Spinner />} {...props} />
  </ErrorBoundary>
);
export default Loader;